
import { defineComponent, ref, provide, onMounted, computed, inject, onUnmounted } from 'vue'
import { useStore } from "vuex";
//components
import ModalSearch from "./ModalSearch.vue";
import ModalPerfil from "./ModalPerfil.vue"
import MixedWidget15 from "@/components/widgets/mixed/Widget15.vue";

import PayrollService from "@/core/services/PayrollService"
import FileService from "@/core/services/FileService"
import { errManager } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";
import { ElTable, ElMessage, ElMessageBox } from 'element-plus'
//import { status_payroll } from "@/core/data/shared"
//import type { CheckboxValueType } from 'element-plus'
import { useRoute } from 'vue-router';

export default defineComponent({
    name: "planilla",
    components: { ModalSearch, ModalPerfil, MixedWidget15 },
    props: {
        previousRoute: {
            type: String,
            required: false,
        },
    },
    setup(props) {
        const store = useStore();
        const route = useRoute();
        const gblAccount = inject<any>('gblAccount')
        const toBack = ref("")

        const ta = ref(process.env.VUE_APP_TA)
        const checkAll = ref(false)
        //const checkAllStatus = ref(false)
        //const indeterminate  = ref(false)
        const { t } = useI18n();
        const loading = ref(false)
        const loading_club = ref(false)
        const selectClub = ref<any>(null)
        const selectStatus = ref<any>([])
        //Pagination start
        const pageSize = ref(10)
        const currentPage = ref(1)
        const totalItems = ref(100)
        //pagination end
        const action = ref<number>(0)
        const dialogSearch = ref(false)
        const dialogProfile = ref(false)
        const dataProfile = ref(<any>{})
        const listPayroll = ref(<any>[])
        const listClubs = ref<any[]>([])
        //const listStatus = ref<any[]>([])
        const resGender = ref<any[]>([])
        const resChecks = ref<any[]>([])
        const listTypeFile = ref<any[]>([])
        const textSearch = ref('')
        const multipleSelection = ref<any[]>([])
        const multipleTableRef = ref<InstanceType<typeof ElTable>>()

        //provide shared data
        provide("dialogSearch", dialogSearch)
        provide("action", action)
        provide("dialogProfile", dialogProfile)
        provide("dataProfile", dataProfile)
        provide("listTypeFile", listTypeFile)

        let intervalId: number

        // Mostrar primer mensaje con botón personalizado
        const showInitialMessage = async () => {
            try {
                await ElMessageBox.alert(
                'Debido al alto volumen de solicitudes en proceso de revisión, se ha habilitado la aprobación automática temporal. La revisión final se realizará durante la evaluación por deporte, donde se validarán todos los datos registrados. Agradecemos su comprensión.',
                'Aviso importante',
                {
                    confirmButtonText: 'Entendido',
                    showClose: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    distinguishCancelAndClose: true,
                    type: 'warning',
                }
                )

                // Inicia el recordatorio cada 50 segundos después de cerrar el primer mensaje
                startReminder()

            } catch (e) {
                // No hacer nada si se cierra de forma inesperada
            }
        }

        const startReminder = () => {
            intervalId = window.setInterval(() => {
                ElMessage({
                message: 'Importante: Debido al alto volumen de solicitudes en proceso de revisión, se ha habilitado la aprobación automática temporal. La revisión final se realizará durante la evaluación por deporte, donde se validarán todos los datos registrados. Agradecemos su comprensión.',
                type: 'warning',
                })
            }, 50000)
        }

        const listStatus: any = computed < any > (() => {
            //return store.getters.currentUser.status_payroll;
            const list = store.getters.currentUser.status_payroll

            // Guardar los ids antes de retornar
            selectStatus.value = list.map((item: any) => item.id)

            return list
        });

        //metodo de respuesta del ModalSearch
        const onResponse = (data) => {
            if (!data.status) {
                action.value = data.action
                dataProfile.value = data
                dialogSearch.value = false
                dialogProfile.value = true
            }
        }

        const getListClubs = async () => {
            loading_club.value = true
            selectClub.value = null
            listClubs.value = []
            listPayroll.value = []
            resGender.value = []
            resChecks.value = []
            await PayrollService.options('clubs', { checkAll: checkAll.value })
                .then((res) => {
                    listClubs.value = res.data
                    loading_club.value = false
                }).catch(({ response }) => {
                    loading_club.value = false
                    errManager(response)
                })
        }

        const geDataPayroll = async () => {
            loading.value = true
            await PayrollService.getData({ textSearch: textSearch.value, idinstitution: selectClub.value, status: selectStatus.value })
                .then((res) => {
                    loading.value = false
                    listPayroll.value = res.data.list
                    resGender.value = res.data.gender
                    resChecks.value = res.data.checks
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        const onResponseMdPerfil = () => {
            geDataPayroll()
        }

        const onEdit = async (row, option) => {
            action.value = option
            dataProfile.value = row
            dialogProfile.value = true
        }

        const getListTypeFile = async () => {
            listTypeFile.value = []
            await FileService.getFiles('payroll', 'type')
                .then((res) => {
                    listTypeFile.value = res.data
                }).catch(({ response }) => {
                    listTypeFile.value = []
                })
        }

        const onDelete = (row) => {
            Swal.fire({
                title: 'Eliminar registro',
                html: `¿Desea eliminar al participante <b>${row.firstname} ${row.lastname}</b> de la planilla?`,
                icon: 'question',
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                },
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Mantener',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return PayrollService.delete(row.idpayroll)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        icon: result.value.status,
                        title: result.value.title,
                        html: result.value.message
                    })
                    result.value.status === 'success' && geDataPayroll();
                }
            })
        }

        const handleSelectionChange = (val: any[]) => {
            multipleSelection.value = []
            val.forEach(item => {
                if (item.hasOwnProperty('check') && (item.check == '0' || item.check == '4')) {
                    multipleSelection.value.push(item);
                }
            });
        }

        const sendDataValidation = () => {
            if (multipleSelection.value.length > 0) {
                Swal.fire({
                    title: 'Envío de información',
                    html: `¿Desea enviar <b>${multipleSelection.value.length} registros</b> para su revisión? Recuerde que una vez enviado no podrá realizar ninguna otra operación hasta que FEDUP haya resuelto la revisión`,
                    icon: 'question',
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Si, enviar!',
                    cancelButtonText: 'Cancelar',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PayrollService.options('review', multipleSelection.value)
                            .then((res) => {
                                return res.data
                            }).catch(({ response }) => {
                                Swal.showValidationMessage(
                                    `Request failed: ${response.data.message}`
                                )
                            })
                    },
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        Swal.fire({
                            icon: result.value.status,
                            title: result.value.title,
                            html: result.value.message
                        })
                        result.value.status === 'success' && geDataPayroll();
                    }

                })
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    html: t('planilla1'),
                });
            }
        }

        onMounted(() => {
            toBack.value = (route.query.backto) ? atob(route.query.backto.toString()) : '/welcome'
            //console.log(route.params)
            getListTypeFile()
            geDataPayroll()
            if (gblAccount) {
                if (gblAccount.value.ta == ta.value) getListClubs()
            }

            showInitialMessage()
        })

        onUnmounted(() => {
            clearInterval(intervalId)
        })

        return {
            toBack,
            gblAccount,
            ta,
            checkAll,
            t,
            loading,
            loading_club,
            selectClub,
            selectStatus,
            pageSize,
            currentPage,
            totalItems,
            action,
            dialogSearch,
            dialogProfile,
            dataProfile,
            listPayroll,
            listClubs,
            listStatus,
            listTypeFile,
            resGender,
            resChecks,
            textSearch,
            //methods
            onResponse,
            onResponseMdPerfil,
            getListTypeFile,
            geDataPayroll,
            onEdit,
            onDelete,
            sendDataValidation,
            handleSelectionChange,
            getListClubs
        }

    },
})
